/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { FunctionComponent, ReactNode, useEffect, useState } from 'react';

import { HeaderPrimary } from '@components/header/header-primary';
import { HeaderSecondary } from '@components/header/header-secondary';
import Spinner from '@components/spinner/spinner';
import {
  EuiBreadcrumb,
  EuiHorizontalRule,
  EuiPageTemplate,
  EuiPageTemplateProps,
  EuiSpacer,
  EuiText,
} from '@elastic/eui';
import { Roles } from '@lib/domain/auth';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
// import { useSession } from 'next-auth/react';

const Footer = dynamic(() => import('@components/footer/footer'), {
  ssr: false,
});

export type Props = {
  breadcrumb?: EuiBreadcrumb[];
  alignment?: 'top' | 'center' | 'horizontalCenter';
  panelled?: boolean;
  restrictWidth?: string | number | boolean;
  pageTitle?: string;
  showSpinner?: boolean;
  role?: Roles;
  sidebar?: ReactNode;
  sidebarWidth?: number;
  show?: boolean;
  showSearch?: boolean;
  isSidebarOpen?: boolean;
  setIsSidebarOpen?: any;
};

const MainLayout: FunctionComponent<EuiPageTemplateProps & Props> = ({
  children,
  breadcrumb,
  pageTitle,
  alignment,
  panelled,
  sidebar,
  sidebarWidth = 400,
  show = true,
  restrictWidth,
  showSpinner = false,
  showSearch = false,
  isSidebarOpen,
  ...rest
}) => {
  const router = useRouter();

  const [showSubHeader, setShowSubHeader] = useState(false);

  // const [showCanvassHeader, setShowCanvassHeader] = useState(false);
  // const { data: session } = useSession();
  // const hasFeature = (feature: string) => session?.features.includes(feature);

  useEffect(() => {
    setShowSubHeader(
      router.route !== '/403' &&
        router.route !== '/error' &&
        !router.route.startsWith('/auth')
    );
    // eslint-disable-next-line prettier/prettier
    // setShowCanvassHeader(router.route === '/canvass/voter-search' || router.route === '/canvass/voter/[voterKey]' || router.route === '/capture/voter-capture/[voterKey]' || router.route === '/capture/capturing-search' );
  }, [router, router.route]);

  const renderPageTitle = (
    <>
      <EuiText size="xs">
        <h2>{pageTitle}</h2>
      </EuiText>
      <EuiHorizontalRule margin="m" color="lightgray" />
    </>
  );

  const handleSideBarVisibility = () => {
    return isSidebarOpen ? 'block' : 'none';
  };

  return (
    <div css={{ position: 'relative' }}>
      <Spinner show={showSpinner} />

      <EuiPageTemplate panelled={panelled} restrictWidth={true} {...rest}>
        <HeaderPrimary showSearch={showSearch} />

        {showSubHeader ? (
          <HeaderSecondary breadcrumb={breadcrumb} show={show} />
        ) : null}

        <EuiSpacer size="s" />

        {sidebar && (
          <EuiPageTemplate.Sidebar
            minWidth={sidebarWidth}
            sticky={true}
            paddingSize={isSidebarOpen ? 's' : 'none'}
            css={{
              overflow: 'hidden',
              display: handleSideBarVisibility(),
              transition:
                'min-width 200ms ease-in-out, padding 200ms ease-in-out',
            }}>
            {sidebar}
          </EuiPageTemplate.Sidebar>
        )}
        <EuiPageTemplate.Section
          grow={true}
          paddingSize="m"
          restrictWidth={restrictWidth === undefined ? 800 : restrictWidth}
          alignment={alignment || 'top'}
          bottomBorder={false}>
          {pageTitle ? renderPageTitle : null}
          {children}
        </EuiPageTemplate.Section>
        <Footer />
      </EuiPageTemplate>
    </div>
  );
};

export default MainLayout;
